export default __webpack_public_path__ + "static/media/line-v-13.b37c10fa.png";